import letterConfig from '@/modules/letter/config'
import BaseModel from '@/modules/base/model/base_model'
import LetterElementCollection from '@/modules/letter/model/letter_element_collection'
import LetterPaperModel from '@/modules/letter/model/letter_letterPaper_model'

export default BaseModel.extend({
  url: letterConfig.saveLetterPaperUrl,

  constructor: function LetterModel() {
    BaseModel.apply(this, arguments)
  },

  props: {
    sender: ['string'],
    letterPaper: ['object', false, () => new LetterPaperModel()],
  },

  collections: {
    header: LetterElementCollection,
    footer: LetterElementCollection,
  },
})
